module.exports = {"date":"날짜","temperature":"온도"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/linechart.json
// module id = WL3+
// module chunks = 2